// `!команда` оператора (ui-plan п.8) — как bash-режим Claude Code:
//
//   ! ls -la
//     ⎿  total 24
//        drwxr-xr-x …
//        … +12 строк
//
// Команда — цветом ввода, вывод — под «⎿» той же схемой, что у инструментов
// агента (раскрытие «… +N строк» на конкретную строку). Пока команда идёт —
// «выполняется… N с» и Esc её прерывает.

import { memo, useEffect, useState } from 'react'
import ToolBlock from '../ToolBlock'
import type { LogLine } from '../../store/logStore'

function Ticker({ since }: { since: number }) {
  const [now, setNow] = useState(() => Date.now() / 1000)
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now() / 1000), 1000)
    return () => window.clearInterval(id)
  }, [])
  const sec = Math.max(0, Math.floor(now - since))
  return <>{sec < 60 ? `${sec} с` : `${Math.floor(sec / 60)} мин ${sec % 60} с`}</>
}

function BashBlock({ sessionId, line }: { sessionId: string; line: LogLine }) {
  const rows = line.rows ?? []
  const failed = !line.partial && line.exitCode !== null && line.exitCode !== undefined && line.exitCode !== 0
  // своя строка «выполняется…» ниже — курсор дописывания ToolBlock здесь лишний
  const out: LogLine = { ...line, kind: failed ? 'warn' : 'result', text: null, gutter: null, head: 8, partial: false }
  return (
    <div className="cli-bash t-row--head">
      <div className="t-row cli-bash__head">
        <span className="t-gut">{line.gutter ?? '!'}</span>
        <span className="t-txt">{line.text}</span>
      </div>
      {rows.length > 0 ? <ToolBlock sessionId={sessionId} line={out} /> : null}
      {line.partial ? (
        <div className="t-res t-res--running">
          <span className="t-gut t-gut--res">{rows.length ? ' ' : '⎿'}</span>
          <div className="t-rows">
            <div className="t-rowline">выполняется… <Ticker since={line.ts} /> · esc — прервать</div>
          </div>
        </div>
      ) : rows.length === 0 ? (
        <div className="t-res">
          <span className="t-gut t-gut--res">⎿</span>
          <div className="t-rows"><div className="t-rowline">(нет вывода)</div></div>
        </div>
      ) : null}
    </div>
  )
}

export default memo(BashBlock)
